<template>
  <div class="tools02-voice">
    <div class="voice-cover">
      <div class="voice-img">
        <img :src="`${rt}/img/lp/koe01.png`" alt="利用者様からの声" />
      </div>
      <div v-if="toolId === '0'" class="tab-4">
        <label v-for="targetToolId in targetToolIdList" :key="targetToolId">
          <input type="radio" name="tab-4" v-model="subToolId" :value="targetToolId">
          {{ $store.getters.toolData(targetToolId).mediaName }}
        </label>
      </div>
      <div class="voice" v-for="(voiceData, index) in voiceList" :key="index">
        <div class="voice-header">
          <div class="voice-title-cover">
            <div class="volume">vol.{{ index + 1 }}</div>
            <p class="voice-title" v-html="voiceData.title"></p>
          </div>
          <p class="name">{{ voiceData.name }}&nbsp;様</p>
        </div>
        <div class="txt" v-html="voiceData.text"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "tools02-voice",
  props: {
    toolId: String,
  },
  data() {
    return {
      // 
      targetToolIdList: ['7', '10', '8', '12', '15', '11'],

      // 
      index: 1,
      subToolId: '7'
    };
  },
  computed: {
    ...mapGetters(['rt']),
    voiceList() {
      // 
      let targetToolId = this.toolId;
      if (this.toolId === '0') {
        targetToolId = this.subToolId;
      } else {
        // no action.
      }

      // 
      let voiceIdList = [];
      switch (targetToolId) {
        case '7':
          voiceIdList = ['17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '1', '2', '3', '5', '6', '7', '29', '30', '31', '8'];
          break;
        case '10':
          voiceIdList = ['32', '33', '1', '12', '13', '10', '11'];
          break;
        case '8':
          voiceIdList = ['34', '14', '15', '16', '35'];
          break;
        case '12':
          voiceIdList = ['36', '37'];
          break;
        case '15':
          voiceIdList = ['38'];
          break;
        case '11':
          voiceIdList = ['39'];
          break;
        default:
          break;
      }

      // 
      return this.$store.getters.voiceListByIdList(voiceIdList);
    },
  },
};
</script>

<style lang="scss" scoped>
.voice-cover {
  width: 100%;
  // width: 900px;
  margin: 0 auto;
  margin-top: 1em;
  box-sizing: border-box;
  padding-bottom: 80px;

  @media screen and (max-width: $max-width) {
    width: 100%;
    margin-top: 10px;
    padding-bottom: 5px;
  }

  .voice-img {
    text-align: center;

    @media screen and (max-width: $max-width) {
      text-align: center;
    }

    img {
      width: 380px;
    }
  }

  .tab-4 {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    margin-top: 1.5em;

    &>label {
      flex: 1 1;
      order: -1;
      position: relative;
      min-width: 70px;
      padding: .7em 1em;
      background-color: #ffffff;
      color: var(--font-color);
      font-size: .9em;
      text-align: center;
      cursor: pointer;
      border-right: solid 1px #ddd;

      @media screen and (max-width: $max-width) {
        min-width: calc(100% / 3);
        border-bottom: solid 1px #ddd;
      }

      &:hover {
        background-color: var(--blue);
        color: #fff;
      }

      &:nth-child(2n) {
        @media screen and (max-width: $max-width) {
          border-right: none;
        }
      }

      &:nth-last-child(2) {

        @media screen and (max-width: $max-width) {
          border-bottom: none;
        }
      }

      &:last-child {
        border-right: none;
        
        @media screen and (max-width: $max-width) {
          border-bottom: none;
        }
      }
    }

    &>div {
      display: none;
      width: 100%;
      padding: 1.5em 1em;
    }

    label {

      &:has(:checked) {
        background-color: var(--blue);
        color: #fff;

        &::before {
          position: absolute;
          bottom: -8px;
          left: 50%;
          transform: translateX(-50%);
          width: 18px;
          height: 9px;
          background-color: var(--blue);
          content: '';
          clip-path: polygon(0 0, 100% 0, 50% 100%);
        }

        &+div {
          display: block;
        }
      }

    }

    input {
      display: none;
    }
  }

  .voice {
    padding: 70px;
    background-color: white;
    margin-top: 20px;
    margin-bottom: 60px;

    @media screen and (max-width: $max-width) {
      padding: 20px;
      padding-bottom: 50px;
    }

    .voice-header {
      display: flex;
      // justify-content: space-between;
      flex-direction: column;
      // align-items: flex-end;
      border-top: 1px solid #ccc;
      border-bottom: 1px solid #ccc;
      padding-top: 15px;
      margin-bottom: 10px;

      @media screen and (max-width: $max-width) {
        display: block;
        padding: 15px 0;
        margin-bottom: 20px;
      }

      p {
        margin: 0;
      }

      .voice-title-cover {
        display: flex;
        align-items: stretch;

        @media screen and (max-width: $max-width) {
          display: block;
        }

        $volume-width: 85px;

        .volume {
          color: white;
          font-weight: bold;
          font-size: 18px;
          background-color: var(--blue);
          display: flex;
          justify-content: center;
          align-items: center;
          width: $volume-width;
          height: 80px;
          margin-right: 10px;

          @media screen and (max-width: $max-width) {
            width: 100%;
            padding: 5px 0;
            min-height: 0;
            height: auto;
          }
        }

        .voice-title {
          font-weight: bold;
          font-size: 24px;
          color: var(--blue);
          width: calc(100% - $volume-width);

          @media screen and (max-width: $max-width) {
            font-size: 22px;
            text-align: left;
            padding: 10px 0;
          }
        }
      }
    }

    .name {
      font-size: 16px;
      font-weight: bold;
      letter-spacing: 0.05em;
      text-align: right;
    }
  }
}
</style>
